const buildTopFive = (filterKey, sorted, sortedArray, labelDescriptor, barColors, colorLabelClasses) => {
  const chartData = { labels: [], datasets: [] };
  let dataTotal = 0;
  let otherTotal = 0;
  const colors = [...barColors];
  const colorClasses = [...colorLabelClasses];
  let color;
  let colorClass;

  sorted.forEach((element, index) => {
    if (index < 5) {
      const filteredMeta = sortedArray.filter((el) => el[filterKey] === Object.keys(element)[0]);
      color = colors.shift();
      colorClass = colorClasses.shift();
      const labelName =
        filterKey === "price"
          ? `$${Math.round(Object.keys(element)[0]).toLocaleString()}`
          : Object.keys(element)[0];

      chartData.datasets.push({
        stack: "1",
        label: `<span class="color-text ${colorClass}">${labelName}${
          labelDescriptor === undefined ? "" : ` ${labelDescriptor}`
        }</span> ${Object.values(element)[0]}`,
        color: colorClass,
        backgroundColor: color[0],
        hoverBackgroundColor: color[1],
        data: [Object.values(element)[0]],
        metaCollection: filteredMeta,
        secondaryTitle: `Showing ${filteredMeta.length} properties with ${
          Object.keys(element)[0]
        } ${filterKey}`,
        index,
        barThickness: 40,
      });

      chartData.labels[index] = `<span class="color-text">${Object.keys(element)[0]}</span> ${
        Object.values(element)[0]
      }`;
      dataTotal += Object.values(element)[0];
    } else {
      const filteredMeta = sortedArray.filter((el) => el[filterKey] === Object.keys(element)[0]);
      color = colors.shift();
      colorClass = colorClasses.shift();
      otherTotal += Object.values(element)[0];

      if (chartData.datasets[5] === undefined) {
        chartData.datasets.push({
          stack: "1",
          label: `<span class="color-text ${colorClass}">Other</span> ${Object.values(element)[0]}`,
          color: colorClass,
          backgroundColor: color[0],
          hoverBackgroundColor: color[1],
          data: [Object.values(element)[0]],
          metaCollection: filteredMeta,
          secondaryTitle: `Showing ${filteredMeta.length} properties with other ${filterKey}`,
          index,
        });
      } else {
        chartData.datasets[5].label = `<span class="color-text ${colorClass}">Other</span> ${otherTotal}`;
        chartData.datasets[5].data[0] += Object.values(element)[0];
        Array.prototype.push.apply(chartData.datasets[5].metaCollection, filteredMeta);
      }
      chartData.labels[5] = `<span class="color-text colorClass">Other</span> ${otherTotal}`;

      dataTotal += Object.values(element)[0];
    }
  });

  chartData.datasets.forEach((dataset, index) => {
    const percentage = Math.round((dataset.data[0] / dataTotal) * 100);

    // eslint-disable-next-line no-param-reassign
    dataset.data[0] = percentage;
    chartData.labels[index] += ` (${percentage}%)`;
    // eslint-disable-next-line no-param-reassign
    dataset.label += ` (${percentage}%)`;
  });

  return chartData;
};

const buildQuartileData = (filterKey, normalAndOutliers, rangeMultiplier, barColors, colorLabelClasses) => {
  const chartData = { labels: [], datasets: [] };
  let dataTotal = 0;
  const colors = [...barColors];
  const colorClasses = [...colorLabelClasses];
  let color;
  let colorClass;

  const rangeM = rangeMultiplier;

  for (let index = 0; index <= 4; index += 1) {
    const dataset = {
      stack: "1",
      label: "",
      data: [0],
      metaCollection: [],
      secondaryTitle: "",
      index,
      barThickness: 40,
    };

    // Calculate range for this quartile
    const min = rangeM * index;
    const max = rangeM * (index + 1);

    dataset.data[0] = normalAndOutliers[0].reduce((acc, dat) => {
      if (
        (index === 0 && dat[filterKey] >= min && dat[filterKey] < max) ||
        (index > 0 && dat[filterKey] >= min && dat[filterKey] < max)
      ) {
        dataset.metaCollection.push(dat);
        return acc + 1;
      }
      return acc;
    }, 0);

    if (dataset.data[0] > 0) {
      color = colors.shift();
      colorClass = colorClasses.shift();
      const [c1, c2] = color;
      dataset.backgroundColor = c1;
      dataset.hoverBackgroundColor = c2;
      dataset.color = colorClass;

      chartData.labels[index] =
        `<span class="color-text ${colorClass}">$${Math.floor(min).toLocaleString()} - $${Math.ceil(max).toLocaleString()}</span> ${dataset.data[0]}`;
      dataset.label = `<span class="color-text ${colorClass}">$${Math.floor(min).toLocaleString()} - $${Math.ceil(max).toLocaleString()}</span> ${dataset.data[0]}`;
      dataset.secondaryTitle = `Showing ${dataset.metaCollection.length} properties in $${Math.floor(min).toLocaleString()} - $${Math.ceil(max).toLocaleString()} range`;

      dataTotal += dataset.data[0];
      chartData.datasets.push(dataset);
    }
  }

  // Outliers (index 5)
  const outlierDataset = {
    stack: "1",
    label: "",
    data: [0],
    metaCollection: [],
    secondaryTitle: "",
    index: 5,
    barThickness: 40,
  };

  outlierDataset.data[0] = normalAndOutliers[1].reduce((acc, dat) => {
    outlierDataset.metaCollection.push(dat);
    return acc + 1;
  }, 0);

  if (outlierDataset.data[0] > 0) {
    color = colors.shift();
    colorClass = colorClasses.shift();
    const [c1, c2] = color;
    outlierDataset.backgroundColor = c1;
    outlierDataset.hoverBackgroundColor = c2;
    outlierDataset.color = colorClass;

    chartData.labels[5] = `<span class="color-text ${colorClass}">Other</span> ${outlierDataset.data[0]}`;
    outlierDataset.label = `<span class="color-text ${colorClass}">Other</span> ${outlierDataset.data[0]}`;
    outlierDataset.secondaryTitle = `Showing ${outlierDataset.metaCollection.length} properties with other range`;

    dataTotal += outlierDataset.data[0];
    chartData.datasets.push(outlierDataset);
  }

  chartData.datasets.forEach((dataset, index) => {
    const percentage = Math.round((dataset.data[0] / dataTotal) * 100);
    // eslint-disable-next-line no-param-reassign
    dataset.data[0] = percentage;
    chartData.labels[index] += ` (${percentage}%)`;
    // eslint-disable-next-line no-param-reassign
    dataset.label += ` (${percentage}%)`;
  });

  return chartData;
};

const sortValues = (sortKey, data) => {
  const multiplier = 1;
  const sorted = data.sort((a, b) => {
    const aVal = a[sortKey] ? a[sortKey] : 0;
    const bVal = b[sortKey] ? b[sortKey] : 0;
    // eslint-disable-next-line no-nested-ternary
    return aVal > bVal ? multiplier : aVal < bVal ? -multiplier : 0;
  });

  return sorted;
};

const options = ({ titleText, showSecondary }) => ({
  indexAxis: "y",
  maintainAspectRatio: false,
  title: {
    display: false,
    text: titleText,
    position: "top",
    fontSize: 12,
    fontFamily: "Open Sans",
    fontStyle: "bold",
  },
  barPercentage: 1,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      titleFont: {
        family: "Open Sans",
        size: 14,
        style: "normal",
      },
      titleColor: "#808080",
      enabled: !showSecondary,
      backgroundColor: "white",
      borderColor: "gray",
      borderWidth: 1,
      titleMarginBottom: 0,
      cornerRadius: 0,
      callbacks: {
        label: () => "",
        title: () => "click for more insights",
      },
    },
  },
  scales: {
    x: {
      stacked: true,
      grid: {
        display: false,
      },
      border: {
        display: false,
      },
      ticks: {
        display: false,
      },
    },
    y: {
      stacked: true,
      grid: {
        display: false,
      },
      border: {
        display: false,
      },
      ticks: {
        display: false,
      },
    },
  },
  layout: {
    padding: 0,
  },
});

export { buildTopFive, buildQuartileData, options, sortValues };
